<template>
  <v-container class="max-container">
    <v-row class="flex-col-center">
      <h1 class="h1--small">O que foi informado no caixa ?</h1>
      <v-col xs="12" sm="12" md="12" lg="12" class="col-form no-pd-b">
        <div style="padding-bottom: 6px">
          <v-icon> mdi-phone </v-icon> Telefone
        </div>

        <v-text-field
          color="var(--cor--preta)"
          placeholder="(88) 8 8888-8888"
          v-mask="['(##) # ####-####', '(##) ####-####']"
          v-model="telephone"
          solo
          clearable
          @keydown.enter="submit({ cpf, telephone })"
        />

        <div class="flex-row-center" style="margin-bottom: 8px">
          <div class="lines" />
          <div class="or">OU</div>

          <div class="lines" />
        </div>

        <div style="padding-bottom: 6px">
          <v-icon> mdi-clipboard-outline </v-icon> CPF
        </div>

        <v-text-field
          solo
          color="var(--cor--preta)"
          placeholder="888.888.888-88"
          v-mask="'###.###.###-##'"
          v-model="cpf"
          clearable
          @keydown.enter="submit({ cpf, telephone })"
        />
        <v-btn
          class="w-100"
          :color="currentCompany.buttonsColor"
          :loading="btnLoading"
          @click="submit({ cpf, telephone })"
        >
          <span class="text-none text-white"> Avançar </span>
          <v-icon right color="var(--cor--branco)">
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <div class="w-100 flex-col-center" style="margin-top: 12px;">
          <v-btn
            :color="currentCompany.buttonsColor"
            text
            class="custom-btn"
            @click="goToLogin()"
          >
            <span class="text-none">
              Já possui uma conta? Acesse por aqui.
            </span>
          </v-btn>
        </div>

        <div class="w-100 flex-col-center">
          <v-btn
            :color="currentCompany.buttonsColor"
            text
            class="custom-btn"
            @click="goToHome()"
          >
            <v-icon left> mdi-chevron-left </v-icon>
            <span class="text-none"> Voltar para o início </span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Service
import {
  getAccessByEmailOrCpf,
  formatTelephoneForUrl,
  formatCpfForUrl,
} from "./service/telephone.service";

export default {
  name: "Telephone",
  computed: {
    ...mapGetters("authenticateStore", {
      currentCompany: "get_currentCompany",
    }),
  },
  data: () => ({
    telephone: "",
    cpf: "",
    btnLoading: false,
  }),
  methods: {
    ...mapActions("signupStore", ["SET_SIGNUP_USER"]),
    ...mapActions("signupStore", ["SET_ACCESS_SIGNUP"]),
    submitAccess() {
      this.btnLoading = true;
      let formattedPhone = formatTelephoneForUrl(this.telephone);
      let formattedCpf = formatCpfForUrl(this.cpf);
      getAccessByEmailOrCpf(
        this.currentCompany.id,
        formattedPhone,
        formattedCpf
      )
        .then((success) => {
          this.btnLoading = false;
          if(!!success.data.email){
              this.SET_SIGNUP_USER(success.data)
              this.$router.push( {path: '/confirmacaoTelefone'} )
          } else {
              this.SET_ACCESS_SIGNUP(true)
              this.SET_SIGNUP_USER({
                birthday: success.data.birthday,
                cpf: this.cpf,
                email: success.data.email,
                genderId: success.data.genderId,
                name: success.data.name,
                telephone: this.telephone, 
              })
              let inviteContactId = location.search.split("?i")[1];
              let path = '/cadastro';

              if (inviteContactId != null) {
                  path = path + '?i' + inviteContactId;
              }
              this.$router.push({path: path});
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          if (error != null) {
            this.$toasted.show(error.message, { type: "error" });
          }
        });
    },
    goToLogin() {
      this.$router.push({ path: "/login" });
    },
    goToHome() {
      this.$router.push({ path: "/inicio" });
    },
    submit(body) {
      const validatedPhone = this.validPhone(body.telephone);
      const validatedCpf = this.validCpf(body.cpf);

      if (validatedPhone || validatedCpf) {
        this.submitAccess();
      } else {
        this.$toasted.show("Por favor, preencha o telefone ou CPF.", {
          type: "info",
        });
      }
    },
    validPhone(telephone) {
      if (!telephone) {
        return false;
      }
      if (telephone.length < 16) {
        return false;
      }
      return true;
    },
    validCpf(cpf) {
      if (!cpf) {
        return false;
      }
      if (cpf.length < 14) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
/*------------------- LOADING -------------------- */
::v-deep .custom-btn.theme--light.v-btn {
  color: var(--cor--branco);
}
@media (max-width: 600px) {
  .h1--small {
    font-size: 24px !important;
  }
}
.col-form {
  max-width: 400px;
}

.h1--small {
  font-size: 28px;
  font-weight: 600 !important;
  margin-bottom: 12px;
}

.lines {
  border: 0.5px solid var(--cor--cinza);
  width: 20%;
  height: 1px;
}

.or {
  color: var(--cor--cinza);
  margin-left: 10px !important;
  margin-right: 10px !important;
  font-size: 16px;
  font-weight: 600;
}
</style>
